import { useDispatch, useSelector } from 'react-redux';

import { actionCreators as modalActions } from '~redux/Modal/actions';

export const useModal = (modal, onOpen, onClose, withData = false) => {
  const dispatch = useDispatch();
  const open = useSelector(state =>
    withData ? state.modal[modal]?.open : state.modal[`${modal}ModalIsOpen`]
  );
  const handleOpenModal = () => {
    withData ? dispatch(modalActions.openModalWithData(modal)) : dispatch(modalActions.openModal(modal));
    if (onOpen) {
      dispatch(onOpen);
    }
  };
  const handleCloseModal = () => {
    withData ? dispatch(modalActions.closeModalWithData(modal)) : dispatch(modalActions.closeModal(modal));
    if (onClose) {
      dispatch(onClose);
    }
  };

  return { open, handleOpenModal, handleCloseModal };
};
